import { getApi } from '@/stores/api'
import { useQuery } from '@tanstack/react-query'

async function getMaterialGroups(signal?: AbortSignal) {
  const api = getApi()
  const res = await api.crt['material-groups'].$get({}, { init: { signal } })
  return res.json()
}

export function useMaterialGroups() {
  return useQuery({
    queryKey: ['materialGroups'],
    queryFn: ({ signal }) => getMaterialGroups(signal),
  })
}
